import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // localStorage
import { persistReducer, persistStore } from "redux-persist";
import rootReducer from "slices";

// Add RESET_APP_STATE support
const appReducer = (state: any, action: any) => {
  if (action.type === "RESET_APP_STATE") {
    const firebaseConfig = state?.config?.firebaseConfig;
    const newState = rootReducer(undefined, action);
    return {
      ...newState,
      config: {
        ...newState.config,
        firebaseConfig,
      },
    };
  }
  return rootReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["teamMember", "billing"], // Don't persist team member and billing state
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
